import styled from "styled-components";
import { useEffect, useState, useContext } from "react";
import { MyContext, useMyContext } from "@/app/utils/MyContext";
import BasicInfo from "../components/BasicInfo/BasicInfo";
import RaceCardPerformance from "@/app/ui/Common/RaceCardPerformance";
import DetailTable from "@/app/ui/RaceDetail/components/RaceCard/DetailTable";
import { text_size } from "@/app/utils/MixinSize";
import { useLanguage } from "@/app/utils/LanguageContext";
const Container = styled.div`
  width: 100%;
  padding: 0;
`;
const Wrapper = styled.div`
  width: 100%;
  border-radius: 0 0 4px 4px;
  padding: 12px 12px 44px 12px;
  background: #C1CBE1;
  .performance {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

const WrapperUnraced = styled.div`
  width: 100%;
  background: #C1CBE1;
  border-radius: 4px;
  padding: 12px 12px 32px 12px;
`;
const DivUnraced = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${text_size(13)}
  font-weight: 500;
  height: 150px;
`;

type propType = {
  data: any;
  meetingDate: string;
  meetingVenueCode: string;
  raceNo: number;
  horseNo: number;
  simulcastHorseId: any;
  gearData: any;
  raceCountry: any;
  horseStatus: any;
  loading: boolean;
  totalRun: number;
};
const HorseProfile: React.FC<propType> = (props) => {
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { state: lang } = useLanguage();
  const { t } = lang;
  console.log("HorseProfile",props.data); 
  const handleChangeTab = (tab: any) => {
    myContextDispatch({
      type: "update",
      value: { ...myContextState, menuTab: tab },
    });
  };
  return (
    <>
      <Container>
        <BasicInfo type="pc" {...props} />
        { props.loading ? null : props.totalRun >= 0 ? <>
        { props.data?.horseFormRecord?.length > 0 ? 
          <Wrapper>
            <RaceCardPerformance
              type="pc"
              page="horseInfo"
              data={{ performanceStats: props?.data?.performanceStats }}
              horseName={props?.data?.name_en}
              raceCountry={props?.raceCountry}
              meetingDate={props?.meetingDate}
              meetingVenueCode={props?.meetingVenueCode}
              raceNo={props?.raceNo}
            />
            <DetailTable
              raceNo={props.raceNo}
              data={{ id: props.simulcastHorseId }}
              gearData={props.gearData}
              type='horseProfile'
            />
          </Wrapper> : <WrapperUnraced><DivUnraced>{t('unraced')}</DivUnraced></WrapperUnraced> 
        }
        </>
        : <WrapperUnraced><DivUnraced>{t('unavailable')}</DivUnraced></WrapperUnraced>
        }
      </Container>
    </>
  );
};
export default HorseProfile;
